<template>
    <div class="subscription-list">
        <div v-for="(singleSubscription, index) in subscriptionPlans" 
             :key="index" 
             class="plan-card mb-3">
            
            <div class="d-flex justify-content-between align-items-center w-100 p-4">
                <!-- LEFT: Plan Name & Actions -->
                <div class="plan-info">
                    <h5 class="plan-title text-uppercase">{{ singleSubscription.name }}</h5>
                    <p class="plan-subtitle text-uppercase mb-3">Subscription Plan</p>
                    
                    <div class="action-buttons d-flex gap-2">
                        <Button class="btn-outline-custom"
                                label="Update"
                                @click="$emit('update', singleSubscription)"
                                icon="pi pi-refresh" />
                        
                        <Button class="btn-outline-danger-custom"
                                label="Delete"
                                @click="$emit('edit', singleSubscription.id, index, singleSubscription.institutionType)"
                                icon="pi pi-trash" />
                    </div>
                </div>

                <!-- RIGHT: Detailed Metrics & Price Box -->
                <div class="plan-stats d-flex align-items-center">
                    <div class="stats-grid-container me-4">
                        <!-- First Row of Stats -->
                        <div class="stats-row mb-2">
                            <div class="stat-item">
                                <span class="stat-label">Emails</span>
                                <div class="stat-value">{{singleSubscription.emails || 0}}</div>
                            </div>
                            <div class="stat-item">
                                <span class="stat-label">SMS</span>
                                <div class="stat-value">{{ singleSubscription.smses || 0 }}</div>
                            </div>
                            <div class="stat-item">
                                <span class="stat-label">WhatsApp</span>
                                <div class="stat-value">{{singleSubscription.whatsapp || 0}}</div>
                            </div>
                        </div>
                        <!-- Second Row of Stats -->
                        <div class="stats-row">
                            <div class="stat-item">
                                <span class="stat-label">Members</span>
                                <div class="stat-value">{{singleSubscription.members}}</div>
                            </div>
                            <div class="stat-item">
                                <span class="stat-label">Families</span>
                                <div class="stat-value">{{singleSubscription.families}}</div>
                            </div>
                            <div class="stat-item">
                                <span class="stat-label">Admin</span>
                                <div class="stat-value">{{singleSubscription.admins}}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Price Box -->
                    <div class="price-box">
                        <span class="price-label">Price</span>
                        <div class="price-value">₹{{singleSubscription.price}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from "primevue/button";
export default {
	name: "InstitutionPlansList",
	components: {Button},
	emits: ["edit", "update"],
	computed: {
		subscriptionPlans: function(){
			return this.plans;
		}
	},
	props: {
		plans: {
			type : Array,
			required: true,
			default(){
				return [];
			}
		}
	}
}
</script>
<style scoped lang="scss">
.subscription-list {
    background-color: #f0f2f5;
    padding: 20px;
}

.plan-card {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.plan-title {
    color: #0f0e0f;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 2px;
}

.plan-subtitle {
    color: #8898aa;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.8px;
}

/* Stats Layout */
.stats-grid-container {
    display: flex;
    flex-direction: column;
    min-width: 300px;
}

.stats-row {
    display: flex;
    justify-content: flex-end;
    gap: 25px;
}

.stat-item {
    text-align: right;
    min-width: 70px;
}

.stat-label {
    font-size: 11px;
    color: #adb5bd;
    display: block;
    font-weight: 600;
}

.stat-value {
    font-size: 15px;
    font-weight: 700;
    color: #1f3b73;
}

/* Price Section */
.price-box {
    background-color: #f1f4ff;
    padding: 12px 25px;
    border-radius: 10px;
    text-align: center;
    min-width: 120px;
    border: 1px solid #e8edff;

    .price-label {
        font-size: 10px;
        color: #8898aa;
        display: block;
        text-transform: uppercase;
        font-weight: 700;
    }

    .price-value {
        font-size: 24px;
        font-weight: 900;
        color: #003399;
    }
}

/* Buttons */
.btn-outline-custom, .btn-outline-danger-custom {
    background: white !important;
    font-size: 12px !important;
    padding: 6px 14px !important;
    border: 1px solid #dee2e6 !important;
    color: #525f7f !important;
    border-radius: 6px !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    
    &:hover {
        background: #f8f9fa !important;
        border-color: #ced4da !important;
    }
}

.btn-outline-danger-custom {
    color: #f5365c !important;
    border-color: #fbbdc8 !important;
    &:hover {
        background: #fff5f7 !important;
    }
}
</style>